import React from "react";
import styles from "./feedcomments.module.scss";
import { KoButton, KoRichTextEditor } from "packages";

export default function FeedAddComment({ onAdd }) {
  const [editorValue, setEditorValue] = React.useState("");
  return (
    <div className={styles.addComment}>
      <KoRichTextEditor
        isToolbar={false}
        onfeedComments={setEditorValue}
        initialValues={editorValue}
        onSetEditorValues={(v) => v}
      />

      <div className={styles.actions}>
        <KoButton onClick={() => onAdd(editorValue)} key="save" type="primary" label="Post" />
      </div>
    </div>
  );
}
